import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { LoginauditExportComponent } from './loginaudit-export/loginaudit-export.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-loginlog',
  templateUrl: './loginlog.component.html',
  styleUrls: ['./loginlog.component.scss']
})
export class LoginLogComponent implements OnInit {
  maxDate :Date = new Date() ; 
  minDate = new Date();
  currentDate : Date = new Date(); 
  subSearchRecords: SubscriptionLike;
  subGetData: SubscriptionLike;
  selectedRow;
  IsAdvanceSearch: boolean = true;
  gridApi: GridApi;
  rowData: any = [];
  columnDefs: any;
  LoginAuditForm: UntypedFormGroup;
  OrgUsersList = [];
  logauditTrailSearch = new LogAuditTrailSearch();
  action: Subject<any> = new Subject();
  totalusers: number;
  activeusers: number;
  inactiveusers: number;
  details_data: any;
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  gridBar:boolean=false;
	gridOptions: { pagination: boolean; rowSelection: string; rowHeight: number; defaultColDef: { sortable: boolean; suppressNavigable: boolean; cellClass: string; suppressMovable: boolean; }; };
  context: any;
  UserName:string="";
  Statuslist:any=[];
  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public ApiService: ApidataRequestService,
    private commonService: CommonService,
  ) { }



  ngOnInit(): void {
    this.gridBar=false;
    this.gridHeaderandActionSettings();
    this.LoginFormControls();
    this.GetOrgUsersList();
    this.LoginAuditForm.get("UserName").patchValue("");
    this.LoginAuditForm.get("Status").patchValue("");
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,     
      
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        
      }
    }
    this.context = { componentParent: this };
    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "S", "label": "Success" },
      { "value": "F", "label": "Failed" }
    ];
  }

  ngOnDestroy(): void {
    if (this.subGetData)
      this.subGetData.unsubscribe();
    if (this.subSearchRecords)
      this.subSearchRecords.unsubscribe();
  }


  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  LoginFormControls() {
    this.LoginAuditForm = new UntypedFormGroup({
      UserName: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      Status: new UntypedFormControl(""),
    })
  }

  GetOrgUsersList() {
    this.subGetData = this.ApiService.getData("api/AdminAuditTrail/GetLoginAuditTrailList").subscribe(
      (res) => {
        if (res.Status) {
           ;
          this.OrgUsersList = res.Data.lstusers;
          this.OrgUsersList = [{ label: "Select", value: "", checked: true }].concat(this.OrgUsersList);
          this.rowData = res.Data.lstLoginADDetails;

          this.rowData.map(rowData => {
            if (rowData && rowData.loginlogout === 'L') {
              rowData.loginlogout = "Login";
            } else {
              rowData.loginlogout = "Logout";
            }

            if (rowData && rowData.status === 'S') {
              rowData.status = "Success";
            } else {
              rowData.status = "Fail";
            }
          })
          this.totalusers = res.Data.TotalUsers;
          this.activeusers = res.Data.ActiveUsers;
          this.inactiveusers = res.Data.InactiveUsers;
          this.details_data = this.rowData;
        } else {
          this.OrgUsersList = [];
          this.rowData = [];
          this.totalusers = 0;
          this.activeusers = 0;
          this.inactiveusers = 0;
          this.details_data = [];
        }
      },

      (err) => {
        //console.error(err);
      }
    );
  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Username", headerTooltip: "Username", field: 'username', sortable: true, tooltipField: "username" },
      { headerName: "IP address", headerTooltip: "IP address", field: 'ipaddress', sortable: true, tooltipField: "ipaddress" },
      { headerName: "Browser and Version", headerTooltip: "Browser and Version", field: 'browserversion', sortable: true, tooltipField: "browserversion" },
      { headerName: "Login/Logout", headerTooltip: "Login/Logout", field: 'loginlogout', sortable: true, tooltipField: "loginlogout" },
      { headerName: "Date and Time", headerTooltip: "Date and Time", field: 'dateandtime', sortable: true, tooltipField: "dateandtime" ,
      comparator : this.dateComparator1
      },
      { headerName: "Status", headerTooltip: "Status", field: 'status', sortable: true, tooltipField: "status" },
      { headerName: "Comments", headerTooltip: "Comments", field: 'comments', sortable: false, tooltipField: "comments" }
    ];

  }


  dateComparator1(valueA: any, valueB: any, node1:any, node2:any, isDescending: boolean) {
    let date1 =new Date(valueA);
    let date2 = new Date(valueB);

    valueA = valueA.split("-")
    valueB =valueB.split("-")

    const day1 = parseInt(valueA[0])
    const month1 = (date1.getMonth() + 1)
    const year1 = parseInt(valueA[2])
    const time1 =  (date1.getTime())
    const day2 = parseInt(valueB[0])
    const month2 = (date2.getMonth() + 1)
    const time2 =  (date2.getTime())
    const year2 = parseInt(valueB[2])

    if (year1 !== year2)
      return year1 - year2
    else if (month1 !== month2)
      return month1 - month2
    else if(day1 !== day2)
      return day1 - day2;
    else{
      return time1- time2 ;
    }
  }

  Clear() {
    this.LoginAuditForm.controls["StartDate"].setValue(null);
    this.LoginAuditForm.controls["EndDate"].setValue(null);
    this.LoginAuditForm.patchValue({
      UserName: "",
      StartDate: null,
      EndDate: null,
      Status: ""
    });
    //this.SDates = "";
    //this.EDates = ""; 
    this.UserName ="";
    this.maxDate = new Date();
  }

  getUserName(event) {
    if(event.label!=null && event.label!="")
    this.UserName = event.label.split("(")[0];
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
    
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
    this.maxDate = new Date(event);
  }

  Search() {
    if (this.ValidateForm()) {
      this.details_data = [];
      this.logauditTrailSearch = new LogAuditTrailSearch();
      this.logauditTrailSearch.UserName = this.LoginAuditForm.controls["UserName"].value;
      this.logauditTrailSearch.StartDate = this.LoginAuditForm.controls["StartDate"].value;
      this.logauditTrailSearch.EndDate = this.LoginAuditForm.controls["EndDate"].value;
      this.logauditTrailSearch.StartDateO = this.Full_Start_Date;
      this.logauditTrailSearch.EndDateO = this.Full_End_Date;
      this.logauditTrailSearch.Status = this.LoginAuditForm.controls["Status"].value;
      this.subSearchRecords = this.ApiService.getDataPost("api/AdminAuditTrail/GetLoginAuditTrailSearch", this.logauditTrailSearch).subscribe(result => {
        if (result.Status && result.Data.length > 0) {
          this.rowData = result.Data;
          this.rowData.map(rowData => {
            if (rowData && rowData.loginlogout === 'L') {
              rowData.loginlogout = "Login";
            } else {
              rowData.loginlogout = "Logout";
            }

            if (rowData && rowData.status === 'S') {
              rowData.status = "Success";
            } else {
              rowData.status = "Fail";
            }
          })
          this.details_data = this.rowData;
        } else {
          this.rowData = [];
          this.details_data = [];
        }
      });
    }
  }

  ValidateForm() {
    var err: any = [];
     
    if (!this.LoginAuditForm.valid) {
      // if (
      //   !this.LoginAuditForm.controls["UserName"].value &&
      //   !this.LoginAuditForm.controls["StartDate"].value &&
      //   !this.LoginAuditForm.controls["EndDate"].value &&
      //   !this.LoginAuditForm.controls["Status"].value
      // ) {
      //   err.push("Provide at least one criteria to perform search");
      //   this.commonService.ValidationBanner(err);
      //   //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
      //   return false;
      // }

      if (!this.LoginAuditForm.controls["UserName"]?.valid) {
        if (this.LoginAuditForm.controls["UserName"].value == "") {
          err.push("Please select the Username");
          this.commonService.ValidationBanner(err);
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
          return false;
        }
      }

      // if (
      //   !this.LoginAuditForm.controls["Status"]?.valid &&
      //   this.LoginAuditForm.controls["StartDate"].value == null &&
      //   this.LoginAuditForm.controls["EndDate"].value == null
      // ) {
      //   err.push("Please select Status /date range");
      //   this.commonService.ValidationBanner(err);
      //   //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
      //   return false;
      // }

      // if (this.LoginAuditForm.controls["StartDate"].value != null) {
      //   if (this.LoginAuditForm.controls["EndDate"].value == null) {
      //     err.push("Please select To date");
      //     this.commonService.ValidationBanner(err);
      //     //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
      //     return false;
      //   }
      // }
      // if (this.LoginAuditForm.controls["StartDate"].value == null) {
      //   if (this.LoginAuditForm.controls["EndDate"].value != null) {
      //     err.push("Please select Form date");
      //     this.commonService.ValidationBanner(err);
      //     //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
      //     return false;
      //   }
      // }
      
      // if (
      //   this.LoginAuditForm.controls["StartDate"].value != null && this.LoginAuditForm.controls["EndDate"].value != null)
      //   {
      //   if (
      //     new Date(this.LoginAuditForm.controls["StartDate"].value) >
      //     new Date(this.LoginAuditForm.controls["EndDate"].value)
      //   ) {
      //     err.push("Start Date should not be greater than End Date");
      //     this.commonService.ValidationBanner(err);
      //     //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation', content: { heading: '', description: err } } });
      //     return false;
      //   }
      // }
    }

    return true;
  }


  onSetGridApi(params) {
    this.gridApi = params.api;;
    this.gridApi.sizeColumnsToFit();
  }

  ExportToPDF() {
     
    if(this.OrgUsersList != null){
      let user = this.OrgUsersList.find(x=> x.value == this.LoginAuditForm.controls["UserName"].value);
      this.UserName = (user.label != "Select" && user != null && user !="")? user.label: "";
    }
    
    let modalRef = this.modalService.open(LoginauditExportComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: {
        ID: null,
        OperationType: "View",
        details_data: this.details_data,
        username_data: this.UserName
      }
    }

  }
}
export class LogAuditTrailSearch {
  UserName?: string = "";
  StartDate?: string = "";
  EndDate?: string = "";
  Status?: string;
  OrgID?: string;
  StartDateO : DateObject;
  EndDateO:DateObject;
}
